import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Course } from '@shared/models/course.model';
import { AnalyticsService, getGeneralStatCards, StatCard, isCompletionEnabled, isScoringEnabled } from '@shared/services/analytics.service';
import { LoadState } from '@app/main/analytics/loader-directive/loader.module';
import { CurrentHubService } from '@shared/services/currentHub.service';
import { Hub } from '@shared/models';
import { Router } from '@angular/router';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
@Component({
  selector: 'experience-card',
  templateUrl: './experience-card.component.html',
  styleUrls: ['./experience-card.component.scss']
})
export class ExperienceCardComponent implements OnInit, OnChanges {
  @Input() course_id: string;
  @Input() date_from: Date;
  @Input() date_to: Date;
  public loadStatus: string;
  public noData = false;
  hub: Hub;
  course: Course;
  public loadError: boolean = false;


  public statsCards: StatCard[];
  constructor(
    private _courseAPIService: CoursesAPIService,
    private _analyticsService: AnalyticsService,
    private _currentHub: CurrentHubService,
    private _router: Router
  ) {

  }
  async ngOnInit(): Promise<void> {
    this.loadStatus = LoadState.loading;
    try {
      this.course = await this._courseAPIService.getCourseById(this.course_id).toPromise();
      await this.updateStats();
    }
    catch (e) {
      this.loadError = true;
    }
    this.loadStatus = LoadState.completed;
    this._currentHub.hubObservable.subscribe(async hub => {
      if (hub) {
        this.hub = hub;
      }
    })
  }
  ngOnChanges(changes: SimpleChanges){
    if (!this.course) return;
    if ((changes.date_from && changes.date_from.currentValue !== changes.date_from.previousValue) || (changes.date_to && changes.date_to.currentValue !== changes.date_to.previousValue)) {
      this.updateStats();

    }
  }
  updateStats(): void{
    this.loadStatus = LoadState.loading;
    this._analyticsService.getCourseStats(this.course_id, { dateFrom: this.date_from, dateTo: this.date_to }).subscribe(stats => {
      this.loadStatus = LoadState.completed;
      this.statsCards = getGeneralStatCards(stats, isCompletionEnabled(this.course), isScoringEnabled(this.course));
    }, () => {
      this.loadStatus = LoadState.error;
    });
  }
  goToAnalytics(): void{
    const url = `${this._router.url}/courses/${this.course.id}`;
    this._router.navigate([url], {
      queryParams: {
        'activeTab': null,
      },
      queryParamsHandling: 'merge'
    });
  }

}
